import { InjectionToken } from '@angular/core';
import { TemplateInterpolator } from './template-interpolator';

/**
 * Multi token for providing `TemplateInterpolator`s for declarative forms.
 */
export const DECLARATIVE_FORMS_TEMPLATE_BUILDER_TOKEN = new InjectionToken<
  TemplateInterpolator[]
>('DECLARATIVE_FORMS.TEMPLATE_BUILDER');
